// const returnEnv = () => {
const env = {
  apiKey: "AIzaSyAxh3pfXb9fqtLLl_fL7cNZYJE4KCZnZXg",
  authDomain: "manufacture-web-app.firebaseapp.com",
  projectId: "manufacture-web-app",
  storageBucket: "manufacture-web-app.appspot.com",
  messagingSenderId: "556794612344",
  appId: "1:556794612344:web:0a8235550a7bc99b4f3b8d",
  measurementId: "G-Y7Z2Y6CEE1",
};

//   return env;
// };
export default env;
